<template>
    <div id="app">
        <h1 class="logo">Oda Konsepti</h1>
        <Reader/>
    </div>
</template>

<script>
    import Reader from './Reader.vue'
    export default {
        name: 'app',
        components: {
            Reader
        }
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// themes/b2b/dev/js/qr/components/App.vue